export const notificationTypes = {
  error: 'error',
  success: 'success',
  warning: 'warning',
} as const;
